/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgentArtifactsControllerGetNutrientConfigQueryResponse, AgentArtifactsControllerGetNutrientConfigPathParams, AgentArtifactsControllerGetNutrientConfigQueryParams } from "../../models/agentArtifactsController/AgentArtifactsControllerGetNutrientConfig";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { agentArtifactsControllerGetNutrientConfig } from "../../clients/agent-artifactsService/agentArtifactsControllerGetNutrientConfig";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const agentArtifactsControllerGetNutrientConfigQueryKey = (artifactId: AgentArtifactsControllerGetNutrientConfigPathParams["artifactId"], params: AgentArtifactsControllerGetNutrientConfigQueryParams) => [{
  url: '/api/v1/agent-artifacts/:artifactId/nutrient-config',
  params: {
    artifactId: artifactId
  }
}, ...(params ? [params] : [])] as const;
export type AgentArtifactsControllerGetNutrientConfigQueryKey = ReturnType<typeof agentArtifactsControllerGetNutrientConfigQueryKey>;
export function agentArtifactsControllerGetNutrientConfigQueryOptions(artifactId: AgentArtifactsControllerGetNutrientConfigPathParams["artifactId"], params: AgentArtifactsControllerGetNutrientConfigQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = agentArtifactsControllerGetNutrientConfigQueryKey(artifactId, params);
  return queryOptions<AgentArtifactsControllerGetNutrientConfigQueryResponse, ResponseErrorConfig<Error>, AgentArtifactsControllerGetNutrientConfigQueryResponse, typeof queryKey>({
    enabled: !!(artifactId && params),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return agentArtifactsControllerGetNutrientConfig(artifactId, params, config);
    }
  });
}

/**
 * @description Uploads the artifact PDF to Nutrient Document Engine if needed, then returns a JWT and server URL for server-based viewing.
 * @summary Get Nutrient Document Engine config for an agent artifact PDF
 * {@link /api/v1/agent-artifacts/:artifactId/nutrient-config}
 */
export function useAgentArtifactsControllerGetNutrientConfig<TData = AgentArtifactsControllerGetNutrientConfigQueryResponse, TQueryData = AgentArtifactsControllerGetNutrientConfigQueryResponse, TQueryKey extends QueryKey = AgentArtifactsControllerGetNutrientConfigQueryKey>(artifactId: AgentArtifactsControllerGetNutrientConfigPathParams["artifactId"], params: AgentArtifactsControllerGetNutrientConfigQueryParams, options: {
  query?: Partial<QueryObserverOptions<AgentArtifactsControllerGetNutrientConfigQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? agentArtifactsControllerGetNutrientConfigQueryKey(artifactId, params);
  const query = useQuery({
    ...agentArtifactsControllerGetNutrientConfigQueryOptions(artifactId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}